import { RootState } from '../index';

const getAttributedOrders = (state: RootState) => state.ordersReducer.attributedOrders;

const getSelectedLocationId = (state: RootState) => state.ordersReducer.selectedLocationId;

const getIsOrdersLoading = (state: RootState) => state.ordersReducer.isOrdersLoading;

const getOrdersMapping = (state: RootState) => state.ordersReducer.ordersMapping;

const getDailyStateSelectedLocation = (state: RootState) => state.ordersReducer.dailyStateSelectedLocation;

const getOrderCounts = (state: RootState) => state.ordersReducer.orderCounts;

const getOrdersChosenDates = (state: RootState) => state.ordersReducer.ordersChosenDates;

const getEmployeeRates = (state: RootState) => state.ordersReducer.employeeRates;

const getChannelData = (state: RootState) => state.ordersReducer.channelData;

const getOrdersTotals = (state: RootState) => state.ordersReducer.ordersTotals;

const getLocationStats = (state: RootState) => state.ordersReducer.locationStats;

const getSalesmanStats = (state: RootState) => state.ordersReducer.salesmanStats;

const getLocationMetrics = (state: RootState) => state.ordersReducer.locationMetrics;

const getOrdersByDates = (state: RootState) => state.ordersReducer.ordersByDates;

const getDorChosenDate = (state: RootState) => state.ordersReducer.dorChosenDate;

const getOrdersByLocation = (state: RootState) => state.ordersReducer.ordersByLocations;

const getDataByMemberAndLocation = (state: RootState) => state.ordersReducer.dataByMemberAndLocation;

const getSelectedOrder = (state: RootState) => state.ordersReducer.selectedOrder;

const getCameFromProductExchanges = (state: RootState) => state.ordersReducer.cameFromProductExchanges;

const getVariantExchangeResult = (state: RootState) => state.ordersReducer.variantExchangeResult;

const getPromotersTotals = (state: RootState) => state.ordersReducer.promotersTotals;

const getMenuOptionName = (state: RootState) => state.ordersReducer.menuOptionName;

export {
  getAttributedOrders,
  getSelectedLocationId,
  getIsOrdersLoading,
  getOrdersMapping,
  getDailyStateSelectedLocation,
  getOrderCounts,
  getOrdersChosenDates,
  getEmployeeRates,
  getChannelData,
  getOrdersTotals,
  getLocationStats,
  getSalesmanStats,
  getLocationMetrics,
  getOrdersByDates,
  getDorChosenDate,
  getOrdersByLocation,
  getDataByMemberAndLocation,
  getSelectedOrder,
  getCameFromProductExchanges,
  getVariantExchangeResult,
  getPromotersTotals,
  getMenuOptionName,
};
